// * ========================================================================
// * Accessible multiselects
// * https://www.npmjs.com/package/@crasman/multiselect
// * ========================================================================

'use strict';

import Multiselect from '@crasman/multiselect'; //npm package

var accessibleMultiselects = (function() {
  const settings = {
    listElement: {size: 12}
  };

  function init() {
    //Make multiselects accessible
    const dropdownElements = document.querySelectorAll('.js-multiselect, .js-select');
    dropdownElements.forEach(select => {
      new Multiselect(select, settings);
    });
  }

  return {
    init: init
  };

})();

export default accessibleMultiselects;
